
import { defineComponent, PropType } from 'vue'
import { maska } from 'maska'

import useValidationMessages from '@/common/composable/useValidationMessages'
import { ErrorObject } from '@vuelidate/core'

export default defineComponent({
    directives: {
        maska,
    },
    props: {
        autocomplete: {
            type: Boolean,
            default: true,
        },
        type: {
            type: String,
            default: 'text',
        },
        value: {
            type: [String, Number],
            default: null,
        },
        maska: {
            type: Object,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isStatic: {
            type: Boolean,
            default: false,
        },
        min: {
            type: [Number, String],
            default: null,
        },
        max: {
            type: [Number, String],
            default: null,
        },
        step: {
            type: [Number, String],
            default: null,
        },
        validationErrors: {
            type: Array as PropType<ErrorObject[]>,
            default: () => [],
        },
        validationErrorStr: {
            type: String,
            default: null
        },
        withTooltip: {
            type: Boolean,
            default: false,
        },
        returnNumber: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const emitInput = (event: Event) => {
            const target = event.target as HTMLInputElement

            if (props.returnNumber && target.value) {
                emit('update:value', Number(target.value))
            } else {
                emit('update:value', target.value)
            }
        }

        const emitChange = (event: Event) => {
            const target = event.target as HTMLInputElement

            if (props.returnNumber && target.value) {
                emit('change', Number(target.value))
            } else {
                emit('change', target.value)
            }
        }

        const { getValidationMessage } = useValidationMessages()

        return { emitInput, emitChange, getValidationMessage }
    },
})
